// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"70169827","806":"b31dc0dc"}[chunkId] + ".chunk.js";
};